export const radius200 = "3px";
export const radius300 = "4px";
export const radius400 = "6px";
export const radius500 = "8px";
export const radius900 = "999999px";
export const radiusRound = "999999px";
export const width0 = "0px";
export const width400 = "1px";
export const width500 = "2px";
export const colorDanger = "#b41522";
export const colorDisabled = "#d5d5d5";
export const colorFocus = "#1b5fa7";
export const colorFocusDanger = "#99121d";
export const colorFocusNeutral = "#333333";
export const colorFocusSuccess = "#186808";
export const colorFocusWarning = "#d98900";
export const colorInvalid = "#b41522";
export const colorInvalidFocus = "#99121d";
export const colorNeutral = "#767676";
export const colorPrimary = "#2277d1";